<script setup>
import AppCreateMessage from "@/components/Forms/AppCreateMessage";
import {useStore} from "vuex";
import {ref, computed, onMounted} from "vue";
import axios from "axios";

const store = useStore()
const isLoading = ref(false)
const messages = ref([])
const isModalVisible = ref(false)
const isModalConfirmRemoveMessage = ref(false)
const removeId = ref(0)

onMounted( ()=>{
  init()
})

const init = async () => {
  isLoading.value = true
  store.commit('menuModule/initMenu')

  // для сертификатов добавлен раздел Сообщения
  // user.value.type = 3
  // обработка будет в dialogue.php

  const url = process.env.VUE_APP_API + "dialogue.php"
  await axios
      .get(`${url}?token=${token.value}&section=${user.value.type}&id=${user.value.id}`)
      .then(response => (messages.value = response.data))
      .catch(error => alert(error));

  //console.log(messages.value)

  if (messages.value.length === 0) {
    setTimeout(() => isLoading.value = false, 3000);
  } else {
    isLoading.value = false
  }

  // убрать метку новое сообщение, если такая была
  // store.commit('menuModule/newMessage', 3)

}

//----------------------------------------------------------------------
// сообщение отправлено
const create = async () => {
  isModalVisible.value = false
  await init()
}

// удалить первую запись, если она имеет статус editable
const confirm = (id) => {
  isModalConfirmRemoveMessage.value = true
  removeId.value = id
}

const removeData = async () => {
  isModalConfirmRemoveMessage.value = false
  messages.value.splice(0, 1)
  const url = process.env.VUE_APP_API + "remove.php";
  const payload = {'id' : removeId.value, 'section' : user.value.type }
  const headers = {
    'Authorization': 'Bearer ' + token.value
  }
  await axios.post(url, payload, {
    headers: headers
  }).catch(error => alert(error));

}

//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
const user = computed( () => {return store.getters['authModule/user']})
</script>

<template>
  <main class="content-wrapper  img-bg">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col"><h3>Мои сообщения</h3></div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12" v-if="user">

            <v-icon-link
                title="Новое сообщение"
                icon="mdi:file-document-plus-outline"
                @click="isModalVisible=true"
            ></v-icon-link>

            <div
                v-if="messages.length"
                class="mb-5 mt-2 messages-content"
            >
              <div v-for="item in messages" :key="item.id">
                <div v-if="Number(item.Status) === 1" class="message question">
                  <div class="message__header d-flex justify-content-between align-items-center">
                    {{ user.name }}
                    <a
                        v-if = "item.Editable"
                        href
                        class="tooltip-custom-link"
                        @click.prevent="confirm(item.Id)"
                    >
                      <v-icon
                          class="action-icon--light"
                          icon="mdi:file-remove-outline"
                      ></v-icon>
                      <span>Удалить сообщение</span>
                    </a>

                  </div>
                  <div class="message__body">
                    <div v-html="item.Msg"></div>
                    <hr>
                    <div class="d-flex justify-content-between">
                      <div>
                        <a
                            v-if="item.Doc"
                            :href="'https://personal.gorcenter.spb.ru/download?t='+token+'&c='+item.Doc+'&u='+user.id+':'+user.type"
                            class="tooltip-custom-link"
                            target="_blank"
                        >
                          <v-icon
                              class="action-icon--red"
                              icon="mdi:file-download-outline"
                          ></v-icon>
                          <span>Скачать документ</span>

                        </a>
                      </div>
                      <div class="text-right">{{ item.Msg_time }}</div>
                    </div>
                  </div>
                </div>
                <div v-else class="message answer">
                  <div class="message__header">
                    <div>
                      СПб ЦДЖ
                    </div>
                  </div>
                  <div class="message__body">
                    <div v-html="item.Msg"></div>
                    <hr>
                    <div class="d-flex justify-content-between">
                      <div>
                        <a
                            v-if="item.Doc"
                            :href="'https://lk.gorcenter.spb.ru/api/download?t='+token+'&c='+item.Doc+'&u='+user.id+':'+user.type"
                            class="tooltip-custom-link"
                            target="_blank"
                        >
                          <v-icon
                              class="action-icon--red"
                              icon="mdi:file-download-outline"
                          ></v-icon>
                          <span>Скачать документ</span>
                        </a>
                      </div>
                      <div>{{ item.Msg_time }}</div>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>

            </div>
            <div v-else class="d-flex justify-content-center">
              <div
                  v-if="isLoading"
                  class="spinner-border text-primary m-4" role="status"
              ></div>
              <div v-else class="p-4">У Вас нет сообщений</div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <teleport to="body">

      <AppCreateMessage
          v-if = "isModalVisible"
          @close = "isModalVisible = false"
          @create = "create"
      ></AppCreateMessage>

      <v-confirm
          v-if="isModalConfirmRemoveMessage"
          title="Сообщение будет удалено. Продолжить?"
          @close="isModalConfirmRemoveMessage = false"
          @confirm="removeData()"
      ></v-confirm>

    </teleport>
  </main>
</template>
<style scoped>
.messages-content{
  max-width: 80%;
}
.message{
  margin: 20px 0 0 0;
}
.answer .message__header{
  background-color: #d4d6d9;
  color:#000;
  border-top-left-radius:10px;
  border-top-right-radius:10px;
  padding:18px;
  font-size: 20px;
}
.question .message__header{
  background-color: #80b5d3;
  color:#fff;
  border-top-left-radius:10px;
  border-top-right-radius:10px;
  padding:18px;
  font-size: 20px;
}
.message__body{
  background-color: #fff;
  border-bottom-left-radius:10px;
  border-bottom-right-radius:10px;
  padding:18px;
  border-left:2px solid #e5e5e5;
  border-right:2px solid #e5e5e5;
  border-bottom:2px solid #e5e5e5
}
.question{
  float:left;
  width:60%
}
.answer{
  float:right;
  width:60%
}

@media only screen and (max-width : 800px) {

  .messages-content{
    max-width: 100%;
  }

  .question{
    float:left;
    width:90%
  }
  .answer{
    float:right;
    width:90%
  }
}
</style>